import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { twMerge } from 'tailwind-merge'

import { Translation } from '@/components/i18n/Translation'

import type { ProductCardProps } from './ProductCardWithInfo'

export const ActionCardButton: FC<
  Pick<ProductCardProps, 'isSingle' | 'isSelected' | 'onCardSelect'> & {
    actionDisabled: boolean
    className?: string
    size?: 'medium' | 'regular'
  }
> = ({ isSingle, isSelected, actionDisabled, className, size, onCardSelect }) =>
  isSingle ? (
    <Button
      variant={isSelected ? 'danger' : 'primary'}
      size={size || 'medium'}
      className={twMerge(
        'm-0 w-full text-wrap py-0 text-sm sm:text-base',
        isSelected && 'basic-shadow',
        className
      )}
      Icon={isSelected ? <></> : undefined}
      disabled={actionDisabled}
      onClick={actionDisabled ? undefined : onCardSelect}
    >
      {isSelected ? <Translation id="Remove" /> : <Translation id="Select" />}
    </Button>
  ) : (
    <Button
      size={size || 'medium'}
      className={twMerge('m-0 w-full text-wrap py-0 text-sm sm:text-base', className)}
      onClick={onCardSelect}
    >
      <Translation id="View models" />
    </Button>
  )
